module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M3.5 13H12v5l6-6-6-6v5H4V2H2v11z\"/></svg>"